// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #f2f2f2;
  border-radius: 12px;
  padding: 16px 16px 16px 12px;
  margin-block: 1rem;
  background-color: white;
}
.main-content div > .text,
.main-content .time {
  display: flex;
  gap: 1.5rem;
}
.main-content .text {
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  padding-bottom: 0.9rem;
}
.main-content .text .send {
  color: #ec6a5e;
}
.main-content .text .received {
  color: #00aa74;
}
.main-content .text .pending {
  color: #dfa102;
}
.main-content .time {
  font-size: 12px;
  color: #8c8c8c;
}
.main-content--preloader {
  width: 30px;
  height: 30px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Common/MyTransactionCard/style.scss","webpack://./src/Styles/sass/_variables.scss"],"names":[],"mappings":"AACA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,4BAAA;EACA,kBAAA;EACA,uBAAA;AAAJ;AACI;;EAEI,aAAA;EACA,WAAA;AACR;AACI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AACR;AAAQ;EACI,cCXG;ADaf;AAAQ;EACI,cCvBI;ADyBhB;AAAQ;EACI,cChBM;ADkBlB;AACI;EACI,eAAA;EACA,cClBS;ADmBjB;AAEI;EACI,WAAA;EACA,YAAA;AAAR","sourcesContent":["@import '../../../Styles/sass/variables';\n.main-content {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border: 1px solid $color_grey_100;\n    border-radius: 12px;\n    padding: 16px 16px 16px 12px;\n    margin-block: 1rem;\n    background-color: white;\n    div > .text,\n    .time {\n        display: flex;\n        gap: 1.5rem;\n    }\n    .text {\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 17px;\n        padding-bottom: 0.9rem;\n        .send {\n            color: $semantic_red;\n        }\n        .received {\n            color: $primary_green;\n        }\n        .pending {\n            color: $semantic_orange;\n        }\n    }\n    .time {\n        font-size: 12px;\n        color: $color_grey_400;\n    }\n\n    &--preloader {\n        width: 30px;\n        height: 30px;\n    }\n}\n// .charging-class{\n//     color: red;\n// }\n","//Primary shades\n$primary_green: #00aa74;\n$primary_light: #e6f7ef;\n$primary_gradient: linear-gradient(109.42deg, #00aa74 0%, #16eba6 100%, #16eba6 100%);\n$primary_gradient1: linear-gradient(108deg, #00AA74 -78.7%, #1E1E1E 59.58%);\n\n//secondary shades\n$secondary_dark: #012515;\n\n//semantic\n$semantic_red: #ec6a5e;\n$semantic_orange: #dfa102;\n\n//Grey Shades\n$color_grey_400: #8c8c8c;\n$color_grey_300: #b3b3b3;\n$color_grey_200: #d9d9d9;\n$color_grey_100: #f2f2f2;\n\n//Black Shades\n$color_black_400: #000000;\n$color_black_300: #1e1e1e;\n$color_black_200: #333333;\n$color_black_100: #4c4c4c;\n\n//green shades\n$color_green_100: #e6f7ef;\n$color_green_150: #c2ead8;\n$color_green_200: #9adcbf;\n$color_green_300: #6ecfa6;\n$color_green_400: #48c493;\n$color_green_500: #09ba80;\n$color_green_600: #009766;\n$color_green_700: #00865a;\n$color_green_800: #006643;\n\n//Fontstyles\n$main_font: 'Syne', sans-serif;\n$secondary_font: 'Outfit', sans-serif;\n$tertiary_font: 'Space Grotesk', sans-serif;\n$text_size: 1rem;\n$dashboardtext: #575757;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
